import { Component, Input } from '@angular/core';
import { OktaLayerViewDetails } from 'private/app/models/user.model';

@Component({
    selector: 'hvac-layer-view-okta-data',
    templateUrl: './layer-view-okta-data.component.html',
    styleUrls: ['./layer-view-okta-data.component.scss']
})
export class LayerViewOktaDataComponent {
    @Input() oktaData: OktaLayerViewDetails[];
}
